import { 
	REQUESTING,
	CREATE_QUIZ
} from '../constants';
import {checkForwardMatch} from '../logics/utility';

const initialState = {
	recipes:[],
	fetchingState:REQUESTING.NONE,
	error:null,
	errorMessage : null,
	unsbcribe : null
};

function handleRestAction(state = initialState, action) {
	
	const {fetchingState} = action.payload;
	
	if(fetchingState === REQUESTING.FETCHING){
		return {
			...state,
			fetchingState,
			error : null,
			errorMessage : null,
		};
	}
	if(fetchingState === REQUESTING.FAIL){
		const {error,message} = action.payload;
		return {
			...state,
			fetchingState,
			error,
			errorMessage : message
		};
	}
	if(fetchingState === REQUESTING.LISTENING){
		const {unsubscribe} = action.payload;
		return {
			...state,
			unsubscribe
		};
	}

	switch (action.type) {
	case CREATE_QUIZ.READ_RECIPES:
	{
		return {
			...state,
			fetchingState,
			recipes:action.payload.newRecipes,
			error : null,
			errorMessage : null,
		};
	}
	case CREATE_QUIZ.INIT_RECIPES:
	{
		return initialState;
	}
	default:
		return state;
	}
}

export default function createQuizReducer(state = initialState, action) {
	if(!checkForwardMatch(action.type,CREATE_QUIZ.PREFIX)){
		return state;
	}
	const {payload} = action;
	if(payload && payload.fetchingState){
		return handleRestAction(state, action);
	}
	return state;
}